import { createSlice } from "@reduxjs/toolkit";

const formSlice = createSlice({
  name: "form",
  initialState: {
    isOpen: false,
    editingId: null,
  },
  reducers: {
    openForm: (state, action) => {
      state.isOpen = true;
      state.editingId = action.payload ?? null;
    },
    closeForm: (state) => {
      state.isOpen = false;
      state.editingId = null;
    },
  },
});

export const { openForm, closeForm } = formSlice.actions;
export default formSlice.reducer;